import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import DropdownMenuItem from './DropdownMenuItem';
export const Direction = {
    TOP_LEFT: 'topLeft',
    TOP_RIGHT: 'topRight',
    BOTTOM_LEFT: 'bottomLeft',
    BOTTOM_RIGHT: 'bottomRight',
};
const DEFAULT_DIRECTION = Direction.BOTTOM_LEFT;
export const Wrapper = styled.div `
  position: absolute;
  padding: 8px 0;

  background-color: #fff;
  border-radius: 2px;
  box-shadow: 2px 4px 16px rgba(0, 0, 0, 0.16);

  cursor: default;
  z-index: 1;

  &.${Direction.TOP_LEFT} {
    right: 0;
    bottom: 100%;
  }

  &.${Direction.TOP_RIGHT} {
    left: 0;
    bottom: 100%;
  }

  &.${Direction.BOTTOM_LEFT} {
    right: 0;
    top: 100%;
  }

  &.${Direction.BOTTOM_RIGHT} {
    left: 0;
    top: 100%;
  }
`;
export default class DropdownMenu extends React.Component {
    constructor() {
        super(...arguments);
        this.handleOutsideClick = (e) => {
            const root = ReactDOM.findDOMNode(this);
            if (!root || !root.contains(e.target)) {
                this.props.onClose();
            }
        };
    }
    componentDidMount() {
        document.addEventListener('click', this.handleOutsideClick);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleOutsideClick);
    }
    render() {
        const { id, direction, children } = this.props;
        return (React.createElement(Wrapper, { id: id, className: `not-open-content ${direction || DEFAULT_DIRECTION}` }, children));
    }
}
DropdownMenu.Item = DropdownMenuItem;
DropdownMenu.Direction = Direction;
